import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import BusinessDashboardCard from './BusinessDashboardCard'
import { SALES_SUMMARY_CARDS } from '../businessDashboardConstants'
import { dispatchHandler } from '../../../../helper/apiHelperFunctions'
import { formatNumber } from '../../../../helper/genericFunction'

// Row 1 : the four sales summary cards, backed by the SALES_KPI_SUMMARY api.
const SalesSummaryCards = () => {
    const dispatch = useDispatch();
    const getSalesKpiSummaryData = useSelector(state => state?.digivendStore?.getSalesKpiSummaryData || {});

    const [cards, setCards] = useState((SALES_SUMMARY_CARDS || []).map(item => ({ ...item, qty: 0, amount: "₹ 0" })));

    useEffect(() => {
        dispatchHandler(dispatch, "getSalesKpiSummaryRequest", { displayName: "SALES_KPI_SUMMARY" });
    }, [dispatch]);

    useEffect(() => {
        if (getSalesKpiSummaryData?.isSuccess) {
            const resource = getSalesKpiSummaryData?.data?.data?.resource || getSalesKpiSummaryData?.data?.resource || {};

            const mapped = SALES_SUMMARY_CARDS.map(item => ({
                ...item,
                qty: (Number(resource?.[item?.qtyField]) || 0).toLocaleString('en-IN'),
                amount: `₹ ${formatNumber(resource?.[item?.amountField] || 0).short}`,
            }));

            setCards(mapped);
        }
    }, [getSalesKpiSummaryData?.isSuccess, getSalesKpiSummaryData?.data]);

    return (
        <div className={`grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-[12px] ${getSalesKpiSummaryData?.isLoading ? 'opacity-50 pointer-events-none' : ''}`}>
            {cards?.map(item => (
                <BusinessDashboardCard key={item?.id} {...item} className='min-h-[120px]' />
            ))}
        </div>
    )
}

export default SalesSummaryCards
